import { Box, Typography } from '@mui/material'
import { Bar, BarChart, CartesianGrid, Tooltip, XAxis, YAxis } from 'recharts'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import { StyledResponsiveContainer, SurfaceTooltip } from '../styles/GraphsStyles'

interface Item {
  foreign_id: number
  foreign_name: string
  image: string
  value: number
  menu: string
}

function PopularContentChart({ data, dataName }: { data: Item[]; dataName: string }) {
  const isMobile = useScreenWidth(960)
  const isLaptop = useScreenWidth(1243)

  const findContent = (content_id: number): Item | null => {
    const contentIndex = data.findIndex(content => content.foreign_id === content_id)
    if (contentIndex >= 0) {
      return data[contentIndex]
    }
    return null
  }

  let responsiveWidth = !isMobile && isLaptop

  const renderCustomAxisTick = ({ x, y, payload }: any) => {
    const content = findContent(payload.value)

    return (
      <svg
        aria-hidden="true"
        focusable="false"
        x={isMobile ? x - 70 : x - 110}
        y={y - 24}
        width={isMobile ? 60 : 90}
        height={60}
        viewBox="0 0 1736 1024"
        fill="#666"
      >
        <foreignObject y="-100" width="100%" height="100%">
          <Box
            style={{
              backgroundImage: `url(${content?.image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              height: '100%',
              width: '100%',
              borderRadius: '16%'
            }}
          />
        </foreignObject>
      </svg>
    )
  }

  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length > 0) {
      return (
        <SurfaceTooltip>
          <Typography>{payload[0].payload.foreign_name}</Typography>
          <Typography variant="body2">{`${dataName}: ${payload[0].value}`}</Typography>
        </SurfaceTooltip>
      )
    }

    return null
  }

  return (
    <StyledResponsiveContainer height={360} width={responsiveWidth ? 'calc(100% - 24px)' : '100%'}>
      <BarChart data={data} layout="vertical" barCategoryGap={16} margin={isMobile ? {} : { top: 5, right: 30, left: 20, bottom: 5 }}>
        <XAxis type="number" />
        <YAxis
          type="category"
          dataKey="foreign_id"
          width={isMobile ? 75 : 110}
          tick={renderCustomAxisTick}
          tickSize={0}
          axisLine={false}
          tickMargin={3}
        />
        <CartesianGrid horizontal={false} strokeDasharray="3 3" />
        <Tooltip cursor={{ fill: '#E0E0E0' }} content={<CustomTooltip />} />
        <Bar dataKey="value" radius={10} fill="#34B3F1" />
      </BarChart>
    </StyledResponsiveContainer>
  )
}

export default PopularContentChart
